import { parseCookies } from '@cian/utils';
import { setRegion } from '../actions/filters/setRegion';
import { getMeta } from '../actions/filters';
import { IApplicationState } from '../types/redux';
import { TThunkDispatch } from '../types/redux/thunk';

export function patchCookieRegion(dispatch: TThunkDispatch, getState: () => IApplicationState): void {
  const cookies = parseCookies(document.cookie);
  const cookieRegion = Number(cookies['session_region_id']) || Number(cookies['forever_region_id']) || null;

  if (!cookieRegion) {
    return;
  }

  const state = getState();
  const jsonQueryRegion = state.filters.jsonQuery.region?.value?.[0] ?? state.mainpage.regionsData.subdomainRegionId;

  if (cookieRegion !== jsonQueryRegion) {
    dispatch(setRegion([cookieRegion]));
    dispatch(getMeta());
  }
}
